import '../vendor';

import '../general/ofi';
import '../general/btn-up';
import './object/sl';
import './object/modal';
import './object/preload-video';
import './object/openghours';


// WEBPACK FOOTER //
// ./src/js/pages/object.js